export interface AthleteStatusInfo {
    label: string;
    icon: string;
    /** Classi Tailwind per il badge di stato. */
    classes: string;
}

/** Etichetta, icona e colori per lo stato di iscrizione stagionale di un atleta. */
export function athleteSeasonStatus(status: string | undefined | null): AthleteStatusInfo {
    switch (status) {
        case 'paid':
            return {label: 'Pagamento effettuato', icon: 'bi-check-circle', classes: 'bg-emerald-50 text-emerald-700'};
        case 'partialPayment':
            return {label: 'Pagamento parziale', icon: 'bi-pie-chart', classes: 'bg-orange-50 text-orange-800'};
        case 'pendingCompanyApprovation':
            return {label: 'In attesa di approvazione', icon: 'bi-hourglass-split', classes: 'bg-amber-50 text-amber-800'};
        case 'verifyingPayment':
            return {label: 'Pagamento in verifica', icon: 'bi-hourglass-split', classes: 'bg-sky-50 text-sky-800'};
        case 'pendingPayment':
            return {label: 'In attesa di pagamento', icon: 'bi-clock', classes: 'bg-amber-50 text-amber-800'};
        default:
            return {label: 'Stato sconosciuto', icon: 'bi-question-circle', classes: 'bg-slate-100 text-slate-600'};
    }
}
